<vl-widget-title [text]="'stats_ligne.ofs_ligne' | trans" [widget]="widget()">
  <ng-content/>
  <vl-aide-context [sections]="aideSections"/>
  <button class="icon-button" [matMenuTriggerFor]="sortMenu">
    <mat-icon>tune</mat-icon>
  </button>
  <mat-menu #sortMenu="matMenu">
    <div class="flex-col gap-8 p-8" (click)="$event.stopPropagation()">
      <vl-chips-toggle [elements]="elementsSort" [(value)]="sortBy"/>
      <vl-chips-toggle [elements]="elementsOrder" [(value)]="sortOrder"/>
    </div>
  </mat-menu>
</vl-widget-title>

<div class="list-container">
  @if (stats() === null) {
    <vl-loader-skeleton/>
  } @else if (rows().length) {
    <table class="w100">
      <thead>
      <tr>
        <th class="text-left">{{ 'stats_ligne.of' | trans }}</th>
        <th class="text-left">{{ 'stats_ligne.article' | trans }}</th>
        <th class="text-right">{{ 'stats_ligne.quantite' | trans }}</th>
        <th class="text-right">{{ 'stats_ligne.date_fin' | trans }}</th>
        <th class="text-right">{{ 'stats_ligne.score' | trans }}</th>
      </tr>
      </thead>
      <tbody>
      @for (row of rows(); track row.id) {
        <tr class="cursor-pointer" (click)="onGoOF(row.id)">
          <td>{{ row.numero }}</td>
          <td class="ellipsis">{{ row.articleDenom }}</td>
          <td class="text-right">{{ row.quantiteProduite | number:'1.0-0' }}</td>
          <td class="text-right">{{ row.dateFin | date:'dd/MM/yyyy' }}</td>
          <td class="text-right">
            <vl-percent [percent]="row.scoreTotal" [typePercent]="TypePercent.OF_TOTAL" [fixed]="2"/>
          </td>
        </tr>
      }
      </tbody>
    </table>
  } @else {
    <div class="flex-row align-center justify-center h100 on-disabled">
      {{ 'stats_ligne.aucune_donnee' | trans }}
    </div>
  }
</div>
